export enum ResidentSourceType {
  EIQ = 'EIQ',
  NorthStar = 'NorthStar',
}
